"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLiveEvent = exports.isLineEvent = exports.isTopEntity = exports.getTopTagId = exports.getEventStatusType = exports.formatScoresByPeriod = exports.getEventMarketsProbabilitiesDeprecated = exports.getEventMarketsProbabilities = exports.getMarketsProbabilitiesDictionaryDeprecated = exports.sortEventPeriodScores = exports.getEventProbabilitiesEnrichedWithPlayerNames = exports.searchEventsByCompetitorsName = exports.getBetOutcomeId = void 0;
exports.getEventTitle = getEventTitle;
exports.getEventTitleWithRenamedCompetitors = getEventTitleWithRenamedCompetitors;
exports.getBetEventTitleWithRenamedCompetitors = getBetEventTitleWithRenamedCompetitors;
exports.getEventLink = getEventLink;
exports.getLineTournamentLink = getLineTournamentLink;
exports.getEventBackLink = getEventBackLink;
exports.getEventSport = getEventSport;
exports.formatDate = formatDate;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const values_1 = __importDefault(require("../functions/values"));
const omit_1 = __importDefault(require("../functions/omit"));
const get_1 = __importDefault(require("../functions/get"));
const sortBy_1 = __importDefault(require("../functions/sortBy"));
const map_1 = __importDefault(require("../functions/map"));
const keyBy_1 = __importDefault(require("../functions/keyBy"));
const dayjs_1 = require("../dayjs");
const slices_1 = require("../@reduxjs/slices");
const logger_1 = require("../logger");
const bets_1 = require("../bets");
const constants_1 = require("./constants");
const date_1 = require("../date");
const types_1 = require("./types");
const competitorNames_1 = require("./competitorNames");
function getEventTitle(event, isBetEvent) {
    if (!event) {
        return '';
    }
    else {
        const { homeCompetitors, awayCompetitors } = isBetEvent
            ? (0, bets_1.getBetEventHomeAwayCompetitors)(event)
            : (0, competitorNames_1.getHomeAwayCompetitors)(event.competitors, event.homeCompetitorIds);
        return (0, competitorNames_1.joinCompetitorNames)([...homeCompetitors, ...awayCompetitors]);
    }
}
function getEventTitleWithRenamedCompetitors({ event, renameDate, isNewSbCompetitorsNameEnabled, }) {
    if (!event)
        return '';
    const { homeCompetitors, awayCompetitors } = (0, competitorNames_1.getHomeAwayCompetitorsRenamed)({
        event,
        renameDate,
        isNewSbCompetitorsNameEnabled,
    });
    return (0, competitorNames_1.joinCompetitorNames)([...homeCompetitors, ...awayCompetitors]);
}
function getBetEventTitleWithRenamedCompetitors(renameDate, isNewSbCompetitorsNameEnabled, event) {
    if (!event)
        return '';
    const { homeCompetitors, awayCompetitors } = (0, competitorNames_1.getBetHomeAwayCompetitorsRenamed)({
        event,
        renameDate,
        isNewSbCompetitorsNameEnabled,
    });
    return (0, competitorNames_1.joinCompetitorNames)([...homeCompetitors, ...awayCompetitors]);
}
function getEventLink(event) {
    return !event
        ? ''
        : event.live
            ? `/live/${event.tournament.sportId}/${event.id}`
            : `/line/${event.tournament.sportId}/${event.tournament.id}/${event.id}`;
}
function getLineTournamentLink(tournament) {
    return !tournament ? '' : `/line/${tournament.sportId}/${tournament.id}`;
}
function getEventBackLink(event) {
    return !event
        ? ''
        : event.live
            ? `/live/${event.tournament.sportId}`
            : getLineTournamentLink(event.tournament);
}
function getEventSport(sports, event) {
    return (0, get_1.default)(sports, `${event === null || event === void 0 ? void 0 : event.tournament.sportId}`);
}
function formatDate(date) {
    return (0, date_1.getFormattedDate)({ date, format: (0, dayjs_1.getFormatForDayjs)() });
}
/*
A standard bet`s unique key: eventId + outcomeTypeId + parameters
@deprecated Use getBetOutcomeKey
 */
const getBetOutcomeId = ({ eventId, outcomeTypeId, parameters = [], }) => `${eventId}-${outcomeTypeId}-${(0, sortBy_1.default)(parameters, ['type'])
    .map((p) => p.value)
    .join('-')}`;
exports.getBetOutcomeId = getBetOutcomeId;
const searchEventsByCompetitorsName = ({ events, searchText, }) => events.filter((event) => event.competitors.some((competitor) => competitor.name.toUpperCase().indexOf(searchText.toUpperCase()) !== -1) && event);
exports.searchEventsByCompetitorsName = searchEventsByCompetitorsName;
const getEventProbabilitiesEnrichedWithPlayerNames = ({ eventProbabilities, playersMap, }) => {
    if (Object.keys(playersMap).length === 0) {
        return eventProbabilities;
    }
    return eventProbabilities.map((eventProbability) => ({
        ...eventProbability,
        parameters: eventProbability.parameters.map((parameter) => {
            if (parameter.type === betweb_openapi_axios_1.ParameterType.PlayerId) {
                const player = playersMap && playersMap[parameter.value];
                if (player) {
                    return { ...parameter, playerName: player.name };
                }
            }
            return parameter;
        }),
    }));
};
exports.getEventProbabilitiesEnrichedWithPlayerNames = getEventProbabilitiesEnrichedWithPlayerNames;
const sortEventPeriodScores = (periodScores) => (0, sortBy_1.default)(periodScores, ['periodNumber']);
exports.sortEventPeriodScores = sortEventPeriodScores;
// TODO remove after PLAT-1313 tests
const getMarketsProbabilitiesDictionaryDeprecated = ({ markets, }) => {
    const probabilitiesDictionary = {};
    for (const market of markets) {
        probabilitiesDictionary[market.marketId] = {
            ...market,
            probabilities: (0, slices_1.toIdsMap)(market.probabilities, 'outcomeTypeId'),
        };
    }
    return probabilitiesDictionary;
};
exports.getMarketsProbabilitiesDictionaryDeprecated = getMarketsProbabilitiesDictionaryDeprecated;
const getEventMarketsProbabilities = ({ newProbabilities, prevProbabilities, }) => {
    /*
      1. Retain markets from previous probabilities that are not present in the new probabilities.
      2. For each new market, merge new trading probabilities with previous probabilities that are not updated in the new market.
     */
    const newMarketsIdsSet = new Set((0, map_1.default)(newProbabilities.markets, 'marketId'));
    const prevMarketsDict = (0, keyBy_1.default)(prevProbabilities.markets, 'marketId');
    const newMergedMarkets = newProbabilities === null || newProbabilities === void 0 ? void 0 : newProbabilities.markets.filter((newMarket) => !newMarket.originalCategoryExcluded).map((newMarket) => {
        const prevMarket = prevMarketsDict[newMarket.marketId];
        if (prevMarket) {
            /*
             If a previous market matches the new market by marketId, merge probabilities:
             new trading probabilities + remaining previous probabilities that are not present in the new market.
             */
            const newMarketProbabilitiesIdsSet = new Set((0, map_1.default)(newMarket.probabilities, 'outcomeTypeId'));
            const tradingNewMarketProbabilities = newMarket.probabilities.filter((probability) => probability.tradingStatus === betweb_openapi_axios_1.EventProbabilityTradingStatus.Trading);
            const remainingPrevMarketProbabilities = prevMarket.probabilities.filter((eventProbability) => !newMarketProbabilitiesIdsSet.has(eventProbability.outcomeTypeId) // TODO: Consider parameters? Test with the backend team on real data.
            );
            return {
                ...newMarket,
                probabilities: [
                    ...tradingNewMarketProbabilities,
                    ...remainingPrevMarketProbabilities,
                ],
            };
        }
        else {
            // If there's no matching previous market, return the new market as is.
            return newMarket;
        }
    });
    const remainingPrevMarkets = prevProbabilities.markets.filter((market) => !newMarketsIdsSet.has(market.marketId));
    return [...remainingPrevMarkets, ...newMergedMarkets];
};
exports.getEventMarketsProbabilities = getEventMarketsProbabilities;
// TODO remove after PLAT-1313 tests
const getEventMarketsProbabilitiesDeprecated = ({ newProbabilities, prevProbabilities, }) => {
    const previousMarketIdsList = [];
    const previousMarketsProbabilitiesDictionary = (0, exports.getMarketsProbabilitiesDictionaryDeprecated)({
        markets: prevProbabilities.markets,
    });
    // todo logs remove after PLAT-1313 tests
    (0, logger_1.logger)('previousMarketsProbabilitiesDictionary', previousMarketsProbabilitiesDictionary);
    const mergedNewMarkets = newProbabilities === null || newProbabilities === void 0 ? void 0 : newProbabilities.markets.map((market) => {
        const previousMarket = previousMarketsProbabilitiesDictionary[market.marketId];
        if (previousMarket) {
            (0, logger_1.logger)('matching market', market.marketId, previousMarket, market);
            // add previous marketIds for omitting them
            previousMarketIdsList.push(market.marketId);
            // save ids for future removing previous market probabilities
            const previousMarketProbabilitiesIdsList = [];
            const previousMarketProbabilitiesDictionary = previousMarket.probabilities;
            market.probabilities.forEach((eventProbability) => {
                const probabilityKey = eventProbability.outcomeTypeId;
                if (previousMarketProbabilitiesDictionary[probabilityKey]) {
                    (0, logger_1.logger)('MATCH prob key', probabilityKey);
                    (0, logger_1.logger)('MATCH prob prev data', previousMarketProbabilitiesDictionary[probabilityKey]);
                    // add id for future removing previous market probability because we get new probability
                    previousMarketProbabilitiesIdsList.push(probabilityKey);
                }
            });
            const newMarketProbabilities = market.probabilities.filter((probability) => probability.tradingStatus === betweb_openapi_axios_1.EventProbabilityTradingStatus.Trading);
            // removing previous market probabilities by ids and return array
            const remainingPreviousMarketProbabilities = ((0, values_1.default)((0, omit_1.default)(previousMarketProbabilitiesDictionary, previousMarketProbabilitiesIdsList)) || []);
            (0, logger_1.logger)('newMarketProbabilities', newMarketProbabilities);
            (0, logger_1.logger)('remainingPreviousMarketProbabilities', remainingPreviousMarketProbabilities);
            return {
                ...market,
                probabilities: [
                    ...newMarketProbabilities,
                    ...remainingPreviousMarketProbabilities,
                ],
            };
        }
        return market;
    }).filter((market) => !market.originalCategoryExcluded);
    (0, logger_1.logger)('mergedNewMarkets', mergedNewMarkets);
    const filteredPreviousMarkets = prevProbabilities.markets.filter((market) => !previousMarketIdsList.includes(market.marketId));
    (0, logger_1.logger)('filteredPreviousMarkets', filteredPreviousMarkets);
    return [...filteredPreviousMarkets, ...mergedNewMarkets];
};
exports.getEventMarketsProbabilitiesDeprecated = getEventMarketsProbabilitiesDeprecated;
const formatScoresByPeriod = (event) => {
    var _a;
    if (!((_a = event === null || event === void 0 ? void 0 : event.basicStatistics) === null || _a === void 0 ? void 0 : _a.scoresByPeriod)) {
        return '';
    }
    return event.basicStatistics.scoresByPeriod
        .map((item) => `${item.homeScore}:${item.awayScore}`)
        .join(', ');
};
exports.formatScoresByPeriod = formatScoresByPeriod;
const getEventStatusType = (event) => {
    let isSpecialStatus = false;
    let completedStatus = false;
    if (event.status === betweb_openapi_axios_1.EventStatus.Cancelled ||
        event.status === betweb_openapi_axios_1.EventStatus.Interrupted ||
        event.status === betweb_openapi_axios_1.EventStatus.Postponed ||
        event.status === betweb_openapi_axios_1.EventStatus.Retired) {
        isSpecialStatus = true;
    }
    if (event.status === betweb_openapi_axios_1.EventStatus.Closed ||
        event.status === betweb_openapi_axios_1.EventStatus.Ended) {
        completedStatus = true;
    }
    return {
        eventStatusType: getStatusBasedOnOtherConditions(event),
        // tags: ['special', 'completed', 'tag3', 'tag4', 'tagN...'], // TODO re-implement via tags
        isSpecialStatus,
        completedStatus,
    };
};
exports.getEventStatusType = getEventStatusType;
const getStatusBasedOnOtherConditions = (event) => {
    const currentDate = new Date();
    const eventDate = new Date(event.eventDate);
    switch (event.status) {
        case betweb_openapi_axios_1.EventStatus.Cancelled:
            return types_1.EEventsStatusList.CANCELED;
        case betweb_openapi_axios_1.EventStatus.Interrupted:
            return types_1.EEventsStatusList.INTERRUPTED;
        case betweb_openapi_axios_1.EventStatus.Postponed:
            return types_1.EEventsStatusList.POSTPONED;
        case betweb_openapi_axios_1.EventStatus.Retired:
            return types_1.EEventsStatusList.COMING;
        default:
            break;
    }
    if (event.live) {
        if (event.status === betweb_openapi_axios_1.EventStatus.Trading ||
            event.status === betweb_openapi_axios_1.EventStatus.Suspended) {
            return event.outcomesCount > 0 ? null : types_1.EEventsStatusList.OUTCOMES_COMING;
        }
    }
    else if (event.status === betweb_openapi_axios_1.EventStatus.Planning ||
        event.status === betweb_openapi_axios_1.EventStatus.Open ||
        event.status === betweb_openapi_axios_1.EventStatus.Suspended) {
        return eventDate > currentDate
            ? event.outcomesCount > 0
                ? null
                : types_1.EEventsStatusList.OUTCOMES_COMING
            : types_1.EEventsStatusList.COMING;
    }
    return null;
};
const getTopTagId = (tags) => {
    const topTag = Object.values(tags).find((tag) => tag.name === types_1.EEntityTagsPlatform.TOP);
    return topTag ? topTag.id : null;
};
exports.getTopTagId = getTopTagId;
const isTopEntity = (entity, topTagId) => {
    var _a;
    return Boolean(topTagId && ((_a = entity.tags) === null || _a === void 0 ? void 0 : _a.includes(topTagId)));
};
exports.isTopEntity = isTopEntity;
__exportStar(require("./competitorNames"), exports);
const isLineEvent = (event) => {
    const isValidDate = new Date(event.eventDate) >= new Date();
    return constants_1.lineEventsStatuses.includes(event.status) && !event.live && isValidDate;
};
exports.isLineEvent = isLineEvent;
const isLiveEvent = (event) => {
    const isValidDate = new Date(event.eventDate) <= new Date();
    return constants_1.liveEventsStatuses.includes(event.status) && event.live && isValidDate;
};
exports.isLiveEvent = isLiveEvent;
//# sourceMappingURL=index.js.map